import React from 'react';
import { Box, Chip, Step, StepLabel, Stepper, Typography, useMediaQuery, useTheme } from '@mui/material';

const EnrollmentStepper = ({ steps, activeStep, capturedMap, onStepSelect }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1 }}>
        <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={600}>
          Step {activeStep + 1}/{steps.length}
        </Typography>
        <Chip
          size="small"
          color="primary"
          label={`${Object.values(capturedMap).filter(Boolean).length}/${steps.length} Captured`}
        />
      </Box>

      <Box sx={{ overflowX: { xs: 'auto', sm: 'visible' }, pb: { xs: 0.5, sm: 0 } }}>
        <Stepper
          alternativeLabel={!isMobile}
          activeStep={activeStep}
          sx={{
            mb: 1,
            minWidth: { xs: 520, sm: 'auto' },
            '& .MuiStep-root': { px: { xs: 0.75, sm: 1 } },
          }}
        >
          {steps.map((step, index) => (
            <Step key={step.key} completed={Boolean(capturedMap[step.key])}>
              <StepLabel
                onClick={() => onStepSelect(index)}
                sx={{ cursor: 'pointer' }}
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default EnrollmentStepper;
